import { shortcuts, display_guide } from "../../config/shortcut-keys";
import editor from '../../helpers/editor';

export default function runShortcutMixin(shortcutName, shortcutAction) {
    return { 
        data: function(){
            return {
                keysPressed: [],
                shortcutName,
                shortcutAction
            }
        },
        created: function(){
            if (!this.addRow) {
                console.error('Please define "addRow" in you Component to be able to use runShortcut Mixin')
            }
            window.addEventListener('keyup', this.handleKeyUp);
            window.addEventListener('keydown', this.handleKeyDown);
        },
        computed: {
            shortcutKeyCodeLabel () {
              return editor.getShortcutAsString(shortcuts[shortcutName], '+');
            }
        },
        beforeDestroy(){
            window.removeEventListener('keyup', this.handleKeyUp);
            window.removeEventListener('keydown', this.handleKeyDown);
        },
        methods: {
            handleKeyDown(e){
                var node = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
                if(node.nodeName === 'INPUT' || node.closest('.form-control'))
                return;
        
                const {keyCode} = e
                this.runShortcut(keyCode, this.shortcutName);  
            },
        
            runShortcut(keyCode, shortcutName ){
                if(shortcuts[shortcutName].find((a) => a.keyCode === keyCode) && !this.keysPressed.find(k => k === keyCode)) this.keysPressed.push(keyCode);
                if(shortcuts[shortcutName].every(k => this.keysPressed.find(kp => k.keyCode === kp))){
                    this.addRow();
                }
            },
        
            removeKeyFromCLipboard(keyCode , shortcutName){
                if(this.keysPressed.length > 0 && shortcuts[shortcutName].some(s => s.keyCode === keyCode)) this.keysPressed = this.keysPressed.filter(kp => kp !== keyCode);
            },
        
            handleKeyUp(e){
                var node = (e.target) ? e.target : ((e.srcElement) ? e.srcElement : null);
                if(node.nodeName === 'INPUT' || node.closest('.form-control'))
                return;
                this.removeKeyFromCLipboard(e.keyCode, this.shortcutName);
            },
    }
}
}
